/**
 * Gender enumeration
 */
export var Gender;
(function (Gender) {
    Gender[Gender["Unspecified"] = 0] = "Unspecified";
    Gender[Gender["Female"] = 1] = "Female";
    Gender[Gender["Male"] = 2] = "Male";
})(Gender || (Gender = {}));
/**
 * Social capabilities supported by different platforms
 */
export var SocialCapability;
(function (SocialCapability) {
    SocialCapability[SocialCapability["FriendsList"] = 0] = "FriendsList";
    SocialCapability[SocialCapability["FriendsInvite"] = 1] = "FriendsInvite";
    SocialCapability[SocialCapability["GamesOfChanceDisabled"] = 2] = "GamesOfChanceDisabled";
    SocialCapability[SocialCapability["RateApplication"] = 3] = "RateApplication";
    SocialCapability[SocialCapability["OutgoingLinksForbidden"] = 4] = "OutgoingLinksForbidden";
    SocialCapability[SocialCapability["AdsAvailable"] = 5] = "AdsAvailable";
    SocialCapability[SocialCapability["LegalDialogsDisabled"] = 6] = "LegalDialogsDisabled";
    SocialCapability[SocialCapability["SupportDialogsDisabled"] = 7] = "SupportDialogsDisabled";
    SocialCapability[SocialCapability["ExternalIncentivesDisabled"] = 8] = "ExternalIncentivesDisabled";
})(SocialCapability || (SocialCapability = {}));
/**
 * Focus change reasons
 */
export var FocusChangedReason;
(function (FocusChangedReason) {
    FocusChangedReason["Hint"] = "hint";
    FocusChangedReason["Pip"] = "pip";
    FocusChangedReason["Other"] = "other";
})(FocusChangedReason || (FocusChangedReason = {}));
/**
 * Buy product error codes
 */
export var BuyProductErrorCode;
(function (BuyProductErrorCode) {
    BuyProductErrorCode[BuyProductErrorCode["Unknown"] = 0] = "Unknown";
    BuyProductErrorCode[BuyProductErrorCode["UserCancelled"] = 1] = "UserCancelled";
})(BuyProductErrorCode || (BuyProductErrorCode = {}));
/**
 * Sticky banner error reasons
 */
export var StickyBannerShowErrorReason;
(function (StickyBannerShowErrorReason) {
    StickyBannerShowErrorReason[StickyBannerShowErrorReason["Unknown"] = 0] = "Unknown";
    StickyBannerShowErrorReason[StickyBannerShowErrorReason["AdsNotConnected"] = 1] = "AdsNotConnected";
    StickyBannerShowErrorReason[StickyBannerShowErrorReason["NotImplemented"] = 999] = "NotImplemented";
})(StickyBannerShowErrorReason || (StickyBannerShowErrorReason = {}));
// Default values
/**
 * Default social settings
 */
export const DefaultSocialSettings = {
    ui: {
        disabled: true
    }
};
// Re-export for backward compatibility
export const FxIdSdkAdapterSocialSettingDefault = DefaultSocialSettings;
export const FxIdSdkAdapterStickyBannerShowErrorReason = StickyBannerShowErrorReason;
export const EFxIdSdkAdapterInfoSocialCapability = SocialCapability;
export const EFxIdSdkAdapterBuyProductResponseErrorCode = BuyProductErrorCode;
export const EFxIdSdkFocusChangedReason = FocusChangedReason;
export const EFxIdSdkGender = Gender;
